import { useEffect } from "react";

// Shared by every dropdown/menu in Automations (step picker, kebab menus,
// row menu) — one listener implementation instead of three copies that could
// drift. Also closes on Escape, which none of the copies supported before.
export default function useOutsideClick(active, onClose) {
  useEffect(() => {
    if (!active) return undefined;
    const close = () => onClose();
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("click", close);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("click", close);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [active, onClose]);
}

// Spread onto any clickable div/span to make it keyboard-operable without
// rewriting it as a <button> — Enter/Space activate it, same as a real button.
export const keyActivate = (onActivate) => ({
  role: "button",
  tabIndex: 0,
  onKeyDown: (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onActivate(e);
    }
  },
});
